export default __webpack_public_path__ + "static/Apercu-Bold-9481cd1b30b7ad5e1ba79126752e237c.eot";